export default __webpack_public_path__ + "static/media/Justin-Bonomo.710fb507.png";